"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _CountryLanguageSelector = _interopRequireDefault(require("./CountryLanguageSelector"));
require("./HeaderCountryLanguage.scss");
var HeaderCountryLanguage = function HeaderCountryLanguage(props) {
  var headerContent = props.headerContent,
    localeCountry = props.localeCountry,
    localeLanguage = props.localeLanguage,
    isEProcurementApp = props.isEProcurementApp,
    isLanguageListJSON = props.isLanguageListJSON;
  var parseList = function parseList(data) {
    var list = [];
    if (!(0, _lodash.isEmpty)(data)) {
      list = JSON.parse(data);
    }
    return list;
  };
  var getCountryName = function getCountryName(countryListParam) {
    if (countryListParam === void 0) {
      countryListParam = [];
    }
    var localeLanguageCountry = (0, _lodash.toLower)("/" + localeCountry + "/" + localeLanguage);
    var selectedCountry = countryListParam && (0, _lodash.filter)(countryListParam, function (item) {
      return item.href.indexOf(localeLanguageCountry) !== -1;
    });
    var country = selectedCountry.length > 0 ? selectedCountry[0] : countryListParam[0];
    var countryNameTitle = (0, _lodash.get)(country, 'title', '');
    var languagesList = (0, _lodash.get)(country, 'languages', []);
    var selectedLanguage = (0, _lodash.find)(languagesList, function (item) {
      return (0, _lodash.toLower)(item.languageCode) === (0, _lodash.toLower)(localeLanguage);
    });
    var languageVal = !(0, _lodash.isEmpty)(selectedLanguage) ? selectedLanguage : (0, _lodash.get)(languageList, ['0']);
    return {
      countryName: countryNameTitle,
      language: languageVal,
      languageList: languagesList
    };
  };
  var getLanguageList = function getLanguageList(languageListJSON) {
    if (languageListJSON === void 0) {
      languageListJSON = [];
    }
    var languageValue = languageListJSON.length > 0 ? languageListJSON[0] : {};
    return {
      countryName: '',
      language: languageValue,
      languageList: languageListJSON
    };
  };
  var countryList = parseList((0, _lodash.get)(headerContent, isEProcurementApp ? 'languageListJson' : 'countryLanguageListJson', ''));
  var _ref = isEProcurementApp ? getLanguageList(countryList) : getCountryName(countryList),
    countryName = _ref.countryName,
    language = _ref.language,
    languageList = _ref.languageList;
  var countrySelectorProps = (0, _extends2.default)({}, props, {
    countryList: countryList,
    languageList: languageList,
    countryName: countryName,
    language: language
  });
  return (isLanguageListJSON || !isEProcurementApp && countryList.length > 0) && _react.default.createElement(_CountryLanguageSelector.default, countrySelectorProps);
};
var _default = HeaderCountryLanguage;
exports.default = _default;
module.exports = exports["default"];